import React from 'react'
import { useTranslation } from 'lib/i18n'

import NotFoundPage from 'components/NotFound/NotFoundPage'

const ProfileNotFoundPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <NotFoundPage
      title={t('profile.slug.404.title', 'Profile not found')}
      subTitle={t(
        'profile.slug.404.subTitle',
        'Sorry, the profile you were looking for does not exist.',
      )}
      backButtonText={t(
        'profile.slug.404.goBack',
        'Check out our other profiles',
      )}
      backButtonHref="/"
    />
  )
}

export default ProfileNotFoundPage
